// extracted by mini-css-extract-plugin
export var header = "_f3-0";